import React from 'react';
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import DoorFrontOutlined from '@mui/icons-material/DoorFrontOutlined';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';
import LocalCafeOutlined from '@mui/icons-material/LocalCafeOutlined';
import NewspaperOutlined from '@mui/icons-material/NewspaperOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import SellOutlined from '@mui/icons-material/SellOutlined';
import ShieldOutlined from '@mui/icons-material/ShieldOutlined';
import StarOutlined from '@mui/icons-material/StarOutlined';
import ThumbUpAltOutlined from '@mui/icons-material/ThumbUpAltOutlined';
import UpdateOutlined from '@mui/icons-material/UpdateOutlined';
import { SERVICE_TYPE_ID } from '../../models/service-type';

// POSITIONS
const TOP = 'TOP';
const MAIN = 'MAIN';
const BOTTOM = 'BOTTOM';

const firstClassService = {
    color: 'primary',
    backgroundColor: '#E8EBF3',
    label: 'booking.categoryItems.firstClassService',
    icon: <StarOutlined />,
};
const premiumService = {
    color: 'primary',
    backgroundColor: '#E8EBF3',
    label: 'booking.categoryItems.premiumService',
    icon: <ThumbUpAltOutlined />,
};
const bestPrice = {
    color: 'primary',
    backgroundColor: '#E8EBF3',
    label: 'booking.categoryItems.bestPrice',
    icon: <SellOutlined />,
};
const doorPickUp = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.doorPickUp',
    icon: <DoorFrontOutlined />,
};
const waitingOnDelay = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.waitingOnDelay',
    icon: <UpdateOutlined />,
};
const individualPickupTime = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.individualPickupTime',
    icon: <AccessTimeOutlined />,
};
const pickupTimeMatchingYourFlight = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.pickupTimeMatchingYourFlight',
    icon: <AccessTimeOutlined />,
};

const meetAndGreet = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.meetAndGreet',
    icon: <HandshakeOutlined />,
};

const meetAndGreetOptional = {
    ...meetAndGreet,
    label: 'booking.categoryItems.meetAndGreetOptional',
};

const drinksIncluded = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.drinksIncluded',
    icon: <LocalCafeOutlined />,
};
const newspaperIncluded = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.newspaperIncluded',
    icon: <NewspaperOutlined />,
};
const freeCancellationWithAsterisk = {
    color: 'info',
    backgroundColor: '#2EA3F21A',
    label: 'booking.categoryItems.freeCancellationWithAsterisk',
    icon: <CheckCircleOutlined />,
};
const privacy = {
    color: 'warning',
    backgroundColor: '#F3F3F3',
    label: 'booking.categoryItems.privacy',
    icon: <ShieldOutlined />,
};
const threePersonsShuttle = {
    color: 'primary',
    backgroundColor: '#E8EBF3',
    label: 'booking.categoryItems.threePersons',
    icon: <PeopleOutlined />,
};

const itemIdToChipsMeta = {
    [SERVICE_TYPE_ID.COLLECTIVE]: {
        TOP: [bestPrice],
        MAIN: [doorPickUp, waitingOnDelay, pickupTimeMatchingYourFlight],
        BOTTOM: [freeCancellationWithAsterisk],
    },
    [SERVICE_TYPE_ID.INDIVIDUAL]: {
        TOP: [premiumService],
        MAIN: [doorPickUp, privacy, waitingOnDelay, individualPickupTime],
        BOTTOM: [freeCancellationWithAsterisk],
    },
    [SERVICE_TYPE_ID.EXCLUSIVE]: {
        TOP: [firstClassService],
        MAIN: [doorPickUp, privacy, waitingOnDelay, individualPickupTime, drinksIncluded, newspaperIncluded],
        BOTTOM: [freeCancellationWithAsterisk],
    },
    [SERVICE_TYPE_ID.UPON_REQUEST]: {
        TOP: [],
        MAIN: [],
        BOTTOM: [freeCancellationWithAsterisk],
    },
    [SERVICE_TYPE_ID.SHARED_INDIVIDUAL]: {
        TOP: [threePersonsShuttle],
        MAIN: [doorPickUp, waitingOnDelay, pickupTimeMatchingYourFlight],
        BOTTOM: [freeCancellationWithAsterisk],
    },
};

const mapItemIdToChips = (serviceTypeId, isMeetAndGreetAvailable) => {
    const chips = {
        ...(itemIdToChipsMeta[serviceTypeId] || {
            TOP: [],
            MAIN: [],
            BOTTOM: [],
        }),
    };

    const isServiceCollective = serviceTypeId === SERVICE_TYPE_ID.COLLECTIVE;

    if (isMeetAndGreetAvailable && !chips.MAIN.includes(meetAndGreet)) {
        if (isServiceCollective) {
            chips.MAIN = [...chips.MAIN, meetAndGreetOptional];
        } else {
            chips.MAIN = [...chips.MAIN, meetAndGreet];
        }
    }

    if (isServiceCollective) {
        chips.BOTTOM = [freeCancellationWithAsterisk, ...chips.BOTTOM];
    }

    return chips;
};

export { mapItemIdToChips, TOP, MAIN, BOTTOM };
